
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/kontakt",
      function () {
        return require("private-next-pages/[locale]/kontakt.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/kontakt"])
      });
    }
  